const faqs = [
  {
    q: '耽美漫画网上的漫画都是免费的吗？',
    a: '是的！耽美漫画网始终坚持全站免费原则，所有耽美漫画和 BL 漫画均可免费在线阅读，无需充值、无需付费会员，点击即可畅享高清画质阅读体验。',
  },
  {
    q: '漫画多久更新一次？',
    a: '我们每日保持高频更新节奏，热门连载作品按作者更新频率同步上线，同时运营团队每日精选新作入库，确保读者每天都能看到新鲜的免费耽美漫画内容。',
  },
  {
    q: '手机可以看漫画吗？',
    a: '完全支持！耽美漫画网采用自适应排版设计，无论手机、平板还是电脑都能获得流畅的高清阅读体验。手机浏览器直接访问即可，无需下载任何 APP。',
  },
  {
    q: '如何找到我想看的漫画？',
    a: '你可以通过首页的专题合集按题材分类浏览，也可以在人气排行中查看热门作品，或使用话题标签快速定位感兴趣的主题。古风、现代、校园、奇幻等多种分类助你精准找漫。',
  },
  {
    q: '网站上的漫画有版权问题吗？',
    a: '耽美漫画网尊重知识产权，所有内容均来源于正版授权或合法合规渠道。我们持续与版权方合作，为读者提供合法、安全的免费耽美漫画阅读环境。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于免费耽美漫画阅读的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-100 rounded-lg overflow-hidden"
              open={idx === 0}
            >
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform flex-shrink-0"></i>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5 pt-0">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}